import { FiUsers } from "react-icons/fi";

export default function StaffList({ data }) {
  // Extract staff list from API data - using newJoiners from API response
  const staffList = data?.newJoiners || [];

  // If no staff data, show empty state
  if (!staffList || staffList.length === 0) {
    return (
      <div className="bg-white p-5 rounded-xl border border-borderColor">
        <h3 className="font-semibold text-gray-900 mb-4">New Joiners</h3>
        <div className="py-8 flex flex-col items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-gray-50 flex items-center justify-center mb-3">
            <FiUsers className="text-gray-300 text-2xl" />
          </div>
          <p className="text-sm text-gray-500">No staff data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white p-5 rounded-xl border border-borderColor">
      <h3 className="font-semibold text-gray-900 mb-4">New Joiners</h3>
      <div className="grid gap-3 md:grid-cols-2">
        {staffList.slice(0, 4).map((person, idx) => {
          const name = person.name || person.first_name || "Unknown";
          const email = person.email || "";
          const dept = person.department?.name || person.department_name || "N/A";
          const role = person.designation?.name || person.designation_name || person.role || "N/A";
          const status = person.status === 1 || person.status === "Active" ? "Active" : "Inactive";
          const initials = name.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();

          return (
            <div key={idx} className="p-4 rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0">
                <span className="text-primary-600 text-sm font-semibold">{initials}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <h4 className="font-semibold text-sm text-gray-900 truncate">{name}</h4>
                  <span
                    className={`text-[10px] px-2 py-0.5 rounded-full font-medium flex-shrink-0 ${
                      status === "Active"
                        ? "bg-green-50 text-green-600"
                        : "bg-red-50 text-red-600"
                    }`}
                  >
                    {status}
                  </span>
                </div>
                {email && <p className="text-xs text-gray-400 truncate mt-0.5">{email}</p>}
                <p className="text-xs text-gray-500 mt-0.5">{dept} &middot; {role}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
